// removed by extract-text-webpack-plugin
module.exports = {"tooltipContainer":"bFUn1","tooltipTrigger":"_2gd_o"};